var qualitySpec = {
    "text-quality-01": {
        "strokepath": [
            {
                "path": "M53.769,43.361c0,0-1.207,6.144-5.266,5.047s-5.595-9.106,1.426-13.824s13.166-3.84,13.824,2.743   s-4.828,20.187-15.689,27.099s-13.056,4.511-10.203-2.072s7.351-7.144,8.997-4.511s12.178,15.908,17.554,16.786   c4.784,0.781,6.144-1.536,6.144-1.536",
                "duration": 200
            },
            {
                "path": "M63.312,59.708l11.3-11.629c0,0-9.875,19.418-6.144,19.309S87.997,51.37,87.997,51.37S79.33,70.393,83.389,69   s10.313-8.744,13.275-10.938s9.106-7.131,11.958-7.351c0,0-11.52,4.937-12.836,11.629s3.511,6.802,5.815,5.156   s11.3-12.397,13.823-16.566c0,0-8.009,9.216-6.912,13.385s6.034,3.181,17.554-9.545s18.809-20.521,18.809-20.521   s-21,28.875-16,32.125s22.5-15.875,22.5-15.875S143,68.25,145.75,67.875S172.875,41.5,172.875,41.5S155,69.25,162,69   s17.75-9.375,21.25-18.125c0,0-9.375,8.125-5.75,13.625s18.875-12.75,19.5-13.875S181.875,74,175.375,80.375   s-20.375,19.875-33.5,8.5",
                "duration": 200
            },
            {
                "path": "M153.5,38.5c0,0,0.625,4.125-0.875,5.25",
                "duration": 100
            },
            {
                "path": "M 159.75 51.25 L 177.375 49.125",
                "duration": 100
            },
            {
                "path": "M218.31,60.157c0,0,6.225-6.026,10.286-10.114c1.646-1.657,2.937-2.996,3.314-3.486c1.308-1.7-4.577-2.746-3.792,7.977   s1.177,17.262-3.662,17.262s-5.884-3.139-3.138-5.493s13.6-2.877,18.7-8.5s8.108-9.676,8.239-7.977s-2.747,8.238-6.669,14.515   S228.64,89.188,228.64,93.111c0,0,12.031-38.838,29.423-42.63c0,0,8.107-1.046,3.923,7.062s-12.684,12.766-15.169,10.723   c0,0-1.177-4.447,13.208-5.362",
                "duration": 100
            },
            {
                "path": "M267.348,60.288c0,0,12.684-3.531,12.554-7.977s-7.322-2.746-10.592,3.989s-1.831,12.096,2.484,11.573   s12.292-5.361,18.308-11.507s8.631-5.754,8.631-5.754s-15.692,7.323-12.946,15.692c0,0,3.662,7.715,11.854-3.138   c6.982-9.25,8.938-12.685,8.938-12.685s-10.77,15.058-7.062,17c5.492,2.877,13.601-7.584,13.601-7.584",
                "duration": 200
            },
            {
                "path": "M332.341,31.911c0,0-14.907,32.562-20.138,39.23c0,0,20.104-20.888,22.623-20.139c0,0-3.515,0.758-10.799,8.4   c0,0,2.429-1.6,3.083,1.8s-0.785,10.307,2.877,8.096s20.007-15.681,24.846-23.265c0,0-2.353-2.092-3.007,2.223   s2.354,17.654-0.523,21.577s-9.278,3.118-7.977-1.438c1.046-3.662,4.576-4.708,7.977-5.1s8.631-2.685,9.938-3.893",
                "duration": 200
            },
            {
                "path": "M378.503,59.725l24.162-27.011c0,0-33.552,51.596-29.648,52.229c0,0,19.519-17.727,21.102-24.268s-3.903-6.542-5.908-2.321   s3.798,8.969,10.551,3.799s13.4-11.606,13.4-11.606s-9.707,8.822-9.707,13.767c0,4.688,6.331,7.335,12.661-1.211   c6.584-8.89,3.271-12.767,0.422-13.083",
                "duration": 200
            },
            {
                "path": "M422.185,60.252c0,0,5.17-5.381,6.331-9.074c0.641-2.038,1.582-5.064,3.06-3.376s3.166,5.947,5.804,5.98   s3.903-1.127,3.903-1.127s-7.28,3.743-9.496,9.229s-0.493,6.829,4.01,5.542c3.692-1.055,10.445-7.702,10.445-7.702",
                "duration": 200
            },
            {
                "path": "M463.755,59.936c0,0,10.763-10.129,11.185-8.546s-8.547,16.414-6.015,16.49s27.645-26.513,27.645-26.513   S477.682,67.408,485.701,69c0,0,10.868-3.472,18.781-13.074s9.074-10.551,9.074-10.551s-3.693-0.316-3.482,7.175   s1.688,17.093-2.954,18.781s-10.089-1.902-3.376-5.909s22.262-5.065,25.322-10.024s0.211-9.074-5.381-3.06   s-7.702,16.355-0.633,15.088s12.871-7.175,20.996-16.565s14.772-15.616,14.772-15.616s-22.58,28.593-15.722,31.97   s35.663-34.186,35.663-34.186s-34.08,53.178-29.438,51.49s26.377-25.534,22.896-27.961s-7.28,0.528-7.175,3.271   s4.326,5.698,9.285,3.376s5.381-3.06,5.381-3.06",
                "duration": 200
            },
            {
                "path": "M476.652,38.5c0,0,0.625,4.125-0.875,5.25",
                "duration": 50
            },
            {
                "path": "M 482.902 51.25 L 500.527 49.125",
                "duration": 50
            }
        ],
        "dimensions": {
            "width": 596,
            "height": 116
        }
    }
};

if($(window).width() <= 1024){
    var greatTaste = {
        "text-great-01":{
            "strokepath": [
                {
                    "path": "M50.951,34.506c0,0,12.34-7.186,7.654-13.746S41.11,27.945,37.83,35.443s-6.405,21.559-0.938,22.026   S57.449,41.691,59.667,35.6S50.482,56.531,45.171,62.78s-17.808,17.34-17.339,4.999",
                    "duration": 50
                },
                {
                    "path": "M61.261,50.908c0,0,8.435-9.527,8.904-12.809s2.812-1.251,4.999,1.249s5.936,5.625,8.748,2.5s-13.747,8.122-11.325,16.714   s19.761-8.591,20.386-8.747s13.747-3.594,13.434-9.686s-16.715,2.344-14.528,16.09s22.182-4.686,24.057-6.561   s10.466-9.686,14.684-10.467s-12.653,4.062-14.684,12.966s2.031,12.34,9.061,6.561s11.715-18.12,14.527-18.901   s-10.31,7.342-8.279,19.37c0,0,0.157,5.937,10.779-3.28s27.493-28.118,27.493-28.118s-18.745,26.243-15.777,31.555   s12.653,0.155,20.151-8.592",
                    "duration": 100
                },
                {
                    "path": "M 151.864 39.974 L 173.89 37.318",
                    "duration": 100
                },
                {
                    "path": "M196.697,50.439l22.182-22.65c0,0-21.713,27.806-14.684,32.805s19.526-9.686,22.807-12.653s8.904-8.123,12.341-8.592   s-12.185,4.53-14.215,11.872s1.25,16.401,13.434,3.124l10.779-14.996c0,0-10.779,9.217-9.061,17.184s8.592,2.656,18.277-6.873   s14.527-14.06,16.402-16.402c1.825-2.28-7.03-2.5-5.78,10.153s2.079,24.983-7.498,22.494c-7.811-2.03,0.797-9.529,4.53-10.31   s11.404-0.781,17.964-7.654s18.12-20.776,18.12-20.776s-16.714,24.995-15.777,30.149s7.03,6.56,20.932-7.03   c0,0,14.059-2.967,14.684-8.278s-7.343-6.404-12.497,3.593s-2.03,14.684,1.406,14.996s11.559-1.563,17.808-10.467",
                    "duration": 100
                },
                {
                    "path": "M 201.5 39.974 L 223.25 37.318",
                    "duration": 100
                },
                {
                    "path": "M 285 39.974 L 307.25 37.318",
                    "duration": 100
                },
                {
                    "path": "M33.988,124.488L63.51,91.51c0,0-39.664,61.376-36.885,63.073s28.551-26.854,28.088-32.41s-10.649-3.086-8.643,2.47   s9.877,6.79,15.587,2.006s13.427-12.191,13.427-12.191s-11.266,6.791-11.266,13.89s6.019,12.191,16.205-1.544   c8.438-11.379,2.315-13.272,0-13.735",
                    "duration": 100
                },
                {
                    "path": "M88.049,125.568c0,0,4.62-4.791,7.253-9.26c2.404-4.078,2.007-7.407,3.396-6.327s5.247,7.802,8.179,7.682   s6.173-3.052,3.704-1.972s-9.917,8.864-10.829,14.198c-1.055,6.173,3.42,8.025,18.236-4.784",
                    "duration": 100
                },
                {
                    "path": "M149.317,112.451c0,0-11.266,14.97-6.791,17.439s20.525-7.563,25.31-17.439s-18.52,28.553-27.008,36.577   s-26.391,25.927-42.75,11.266",
                    "duration": 100
                },
                {
                    "path": "M169.689,124.953c0,0,11.729-7.563,12.346-9.724s-10.597,7.23-10.34,13.89c0.309,8.025,7.562,8.489,15.433-2.469   s1.852-13.427,0-13.272",
                    "duration": 100
                },
                {
                    "path": "M195.308,125.416c0,0,14.043-15.417,14.507-14.576s-11.111,19.977-8.025,22.446s23.458-19.6,24.384-19.291   s-8.952,20.185-5.71,20.664s8.875-4.661,14.816-10.462c5.865-5.727,7.408-12.672,8.334-14.215s3.396,3.395,6.173,5.247   s4.321,2.779,6.481,0.772s-10.593,6.397-11.575,13.272c-1.234,8.642,6.328,8.643,18.674-4.013",
                    "duration": 100
                },
                {
                    "path": "M286.209,124.644c0,0,12.81-12.347,14.044-10.031s-11.884,20.526-11.884,20.526s23.304-23.574,27.625-20.815   s-9.569,21.124-8.488,20.815s25.003-24.023,27.317-21.04s-11.42,19.659-8.951,21.044s15.588-8.647,18.52-11.733   c0,0,16.514-4.479,13.427-9.57s-11.883,2.009-13.581,7.719s-1.852,9.876,0.617,11.574s8.95,4.785,24.229-12.5   c0,0,7.408-9.568,8.643-7.871s-4.32,17.246-11.111,22.513c0,0,20.988-23.902,28.859-20.661c0,0,2.625,1.318-2.623,9.07   s-4.013,11.263-2.47,11.591s5.71-0.443,28.088-21.741c0,0-9.877,19.446-5.71,20.218s21.76-16.515,23.304-19.292   s-10.031,20.218-5.71,20.218s14.198-10.187,14.198-10.187",
                    "duration": 100
                }
            ],
            "dimensions": {
                "width": 610,
                "height": 184
            }
        }
    };
}else{
    var greatTaste = {
        "text-great-01":{
            "strokepath": [
                {
                    "path": "M50.951,34.506c0,0,12.34-7.186,7.654-13.746S41.11,27.945,37.83,35.443s-6.405,21.559-0.938,22.026   S57.449,41.691,59.667,35.6S50.482,56.531,45.171,62.78s-17.808,17.34-17.339,4.999",
                    "duration": 300
                },
                {
                    "path": "M61.261,50.908c0,0,8.435-9.527,8.904-12.809s2.812-1.251,4.999,1.249s5.936,5.625,8.748,2.5s-13.747,8.122-11.325,16.714   s19.761-8.591,20.386-8.747s13.747-3.594,13.434-9.686s-16.715,2.344-14.528,16.09s22.182-4.686,24.057-6.561   s10.466-9.686,14.684-10.467s-12.653,4.062-14.684,12.966s2.031,12.34,9.061,6.561s11.715-18.12,14.527-18.901   s-10.31,7.342-8.279,19.37c0,0,0.157,5.937,10.779-3.28s27.493-28.118,27.493-28.118s-18.745,26.243-15.777,31.555   s12.653,0.155,20.151-8.592",
                    "duration": 700
                },
                {
                    "path": "M 151.864 39.974 L 173.89 37.318",
                    "duration": 300
                },
                {
                    "path": "M196.697,50.439l22.182-22.65c0,0-21.713,27.806-14.684,32.805s19.526-9.686,22.807-12.653s8.904-8.123,12.341-8.592   s-12.185,4.53-14.215,11.872s1.25,16.401,13.434,3.124l10.779-14.996c0,0-10.779,9.217-9.061,17.184s8.592,2.656,18.277-6.873   s14.527-14.06,16.402-16.402c1.825-2.28-7.03-2.5-5.78,10.153s2.079,24.983-7.498,22.494c-7.811-2.03,0.797-9.529,4.53-10.31   s11.404-0.781,17.964-7.654s18.12-20.776,18.12-20.776s-16.714,24.995-15.777,30.149s7.03,6.56,20.932-7.03   c0,0,14.059-2.967,14.684-8.278s-7.343-6.404-12.497,3.593s-2.03,14.684,1.406,14.996s11.559-1.563,17.808-10.467",
                    "duration": 1000
                },
                {
                    "path": "M 201.5 39.974 L 223.25 37.318",
                    "duration": 300
                },
                {
                    "path": "M 285 39.974 L 307.25 37.318",
                    "duration": 300
                },
                {
                    "path": "M33.988,124.488L63.51,91.51c0,0-39.664,61.376-36.885,63.073s28.551-26.854,28.088-32.41s-10.649-3.086-8.643,2.47   s9.877,6.79,15.587,2.006s13.427-12.191,13.427-12.191s-11.266,6.791-11.266,13.89s6.019,12.191,16.205-1.544   c8.438-11.379,2.315-13.272,0-13.735",
                    "duration": 300
                },
                {
                    "path": "M88.049,125.568c0,0,4.62-4.791,7.253-9.26c2.404-4.078,2.007-7.407,3.396-6.327s5.247,7.802,8.179,7.682   s6.173-3.052,3.704-1.972s-9.917,8.864-10.829,14.198c-1.055,6.173,3.42,8.025,18.236-4.784",
                    "duration": 300
                },
                {
                    "path": "M149.317,112.451c0,0-11.266,14.97-6.791,17.439s20.525-7.563,25.31-17.439s-18.52,28.553-27.008,36.577   s-26.391,25.927-42.75,11.266",
                    "duration": 300
                },
                {
                    "path": "M169.689,124.953c0,0,11.729-7.563,12.346-9.724s-10.597,7.23-10.34,13.89c0.309,8.025,7.562,8.489,15.433-2.469   s1.852-13.427,0-13.272",
                    "duration": 300
                },
                {
                    "path": "M195.308,125.416c0,0,14.043-15.417,14.507-14.576s-11.111,19.977-8.025,22.446s23.458-19.6,24.384-19.291   s-8.952,20.185-5.71,20.664s8.875-4.661,14.816-10.462c5.865-5.727,7.408-12.672,8.334-14.215s3.396,3.395,6.173,5.247   s4.321,2.779,6.481,0.772s-10.593,6.397-11.575,13.272c-1.234,8.642,6.328,8.643,18.674-4.013",
                    "duration": 300
                },
                {
                    "path": "M286.209,124.644c0,0,12.81-12.347,14.044-10.031s-11.884,20.526-11.884,20.526s23.304-23.574,27.625-20.815   s-9.569,21.124-8.488,20.815s25.003-24.023,27.317-21.04s-11.42,19.659-8.951,21.044s15.588-8.647,18.52-11.733   c0,0,16.514-4.479,13.427-9.57s-11.883,2.009-13.581,7.719s-1.852,9.876,0.617,11.574s8.95,4.785,24.229-12.5   c0,0,7.408-9.568,8.643-7.871s-4.32,17.246-11.111,22.513c0,0,20.988-23.902,28.859-20.661c0,0,2.625,1.318-2.623,9.07   s-4.013,11.263-2.47,11.591s5.71-0.443,28.088-21.741c0,0-9.877,19.446-5.71,20.218s21.76-16.515,23.304-19.292   s-10.031,20.218-5.71,20.218s14.198-10.187,14.198-10.187",
                    "duration": 1000
                }
            ],
            "dimensions": {
                "width": 610,
                "height": 184
            }
        }
    };
}

var flexibleConsistent = {
    "text-flexible": {
        "strokepath": [
            {
                "path": "M48.834,38.734c0,0-22.174,31.484-21.824,39.855",
                "duration": 100
            },
            {
                "path": "M44.467,40.736c0,0-6.415,9.527-10.783,10.619s-7.35-5.34-2.436-10.617s13.037-6.37,22.682-6.007   s18.199-0.365,18.745-4.732",
                "duration": 100
            },
            {
                "path": "M28.707,57.947c0,0,7.701-1.29,11.14-0.717s7.932,0.424,10.844-0.146",
                "duration": 100
            },
            {
                "path": "M48.834,63.822l29.988-33.245c0,0-21.087,28.617-21.208,37.114c-0.143,10.03,9.602,3.438,18.629-5.159   c0,0,13.613-4.156,13.613-9.744s-12.18-0.86-14.187,8.168s2.579,14.33,8.455,11.894c7.895-3.273,11.607-8.598,11.607-8.598",
                "duration": 100
            },
            {
                "path": "M117.947,43.188c0,0,6.018-1.862,5.302,1.72s-7.452,11.608-13.04,18.199S92.583,80.029,93.013,78.59   s8.741-13.912,10.317-19.928s5.016-8.596,6.162-4.583s3.439,18.199,6.735,18.199s27.226-23.214,26.796-19.632   s-10.798,18.471-7.308,19.632c2.723,0.905,15.762-11.608,19.345-16.623s10.747-6.448,16.623-10.891s17.339-16.336,14.33-18.342   s-25.078,10.891-30.093,24.934s-5.055,22.028-1.719,21.781c5.797-0.43,16.909-12.896,16.479-17.482   c-0.41-4.376-1.698,8.445,0.287,11.751c1.72,2.865,6.722-1.003,15.541-10.461s23.006-26.653,23.006-26.653   s-23.644,32.242-20.921,39.693s15.906-6.161,17.625-7.451c0,0,16.193-3.647,14.473-10.063s-11.607,0.748-14.187,7.483   s-0.86,12.467,2.866,13.04c4.824,0.742,10.174-1.289,17.625-9.457",
                "duration": 900
            },
            {
                "path": "M145.317,36.023c0,0,0,5.732-1.719,7.309",
                "duration": 100
            },
            {
                "path": "M249.491,63.198c0,0,14.482-11.37,19.509-11.609s-12.687-1.437-17.115,16.157c0,0-1.6,5.513,3.71,5.386   c5.027-0.12,11.594-6.64,14.294-10.74s8.924-11.735,7.009-10.91s-11.49,13.272-9.216,20.095s10.054-1.677,12.926-4.189   s13.764-16.277,16.756-16.995c0.931-0.224,3.351-0.479,0.957,4.309s-8.617,15.559-11.25,18.072s15.199-15.559,19.867-17.952   s11.37-4.788,8.139,3.351s-7.54,13.285-4.069,14.362s13.884-7.712,15.799-10.259s15.199-7.813,13.644-9.01   s-9.949,6.388-11.968,13.404c-2.514,8.736,4.799,9.813,12.094,0.239s13.279-27.408,6.098-37.581   c-4.288-6.074-18.191-8.977-28.844,7.062",
                "duration": 700
            },
            {
                "path": "M387.515,54.35c0,0,2.655-14.668,10.162-16.746c0,0-3.581,5.891-1.732,7.392s8.316-1.617,9.471-12.011   s-10.855-2.888-13.05-1.271s-14.321,11.318-16.284,30.258s16.976,7.392,19.401,5.428s16.284-11.665,15.476-13.628   s-10.043,7.189-10.51,13.628c-0.577,7.968,3.811,6.352,5.774,5.89s11.548-5.196,12.588-13.05s0.116-8.547-2.887-8.662",
                "duration": 100
            },
            {
                "path": "M424.582,63.356c0,0,9.585-9.239,11.317-11.779s4.734-2.54,2.656,2.541s-11.895,19.62-11.895,19.62   s17.208-18.119,22.866-19.967s8.315-1.617,4.966,6.005s-7.276,13.975-2.426,13.166s15.128-10.51,20.21-15.129   s8.547-9.47,10.51-10.74s-2.888-4.653-3.812,1.427s1.04,12.778,0.231,19.477s-2.194,10.855-6.236,10.855s-7.854-5.081-2.079-8.661   s14.436-3.118,18.478-6.583s8.2-8.314,10.972-10.047s2.771-0.231,0,5.543s-6.235,12.703-3.811,13.512s7.967-5.081,14.088-11.202   s9.816-10.774,12.473-12.894s0.23-4.891-1.155-2.004s-0.783,12.743-0.09,21.058s-4.756,12.333-9.495,10.585   c-4.724-1.742-2.079-7.854,3.349-9.47s10.856-0.461,15.938-5.196s19.633-20.209,21.48-22.52s-9.514,12.68-12.979,21.109   s-3.189,12.649,1.314,12.284s16.86-9.836,18.246-11.452c0,0,14.873-4.1,13.567-10.818c-0.971-4.993-11.572,0.819-13.798,8.278   c-2.644,8.858,0.229,13.281,3.926,13.05s10.34-2.383,18.361-11.896c0,0,9.486-12.419,11.153-11.056s-2.728,12.578-5.304,16.973   s-4.395,5.759-4.395,5.759s13.79-15.609,18.791-18.186s11.213-4.849,8.94,2.122s-8.638,15.153-4.546,15.76   s10.607-4.545,17.882-12.274s18.943-20.762,18.943-20.762S628,63.095,627.764,69.244c-0.303,7.88,6.213,7.729,20.155-5.607",
                "duration": 1000
            },
            {
                "path": "M505.249,36.866c0,0,0.153,4.021-1.393,6.032",
                "duration": 100
            },
            {
                "path": "M537.107,52.486c0,0,13.146-0.618,21.343-2.319",
                "duration": 100
            },
            {
                "path": "M626.846,52.486c0,0,13.146-0.618,21.343-2.319",
                "duration": 100
            }
        ],
        "dimensions": {
            "width": 694,
            "height": 97
        }
    }
};


var Conclusion = {
    "text-Conclusion-06": {
        "strokepath": [
            {
                "path": "M45.508,53.698c0,0,3.372-15.278,10.537-17.28c0,0-5.146,7.238-1.686,8.64c4.425,1.792,12.011-12.222,8.429-16.015   s-12.75-1.855-21.917,11.695c-9.256,13.683-8.876,28.706-3.372,30.557c7.481,2.515,17.385-4.742,24.023-10.537   s7.586-7.586,7.586-7.586s-10.822,5.87-10.747,13.908c0.105,11.274,14.646,4.637,17.807-5.584s-0.105-11.381-1.896-10.748",
                "duration": 300
            },
            {
                "path": "M82.282,62.442c0,0,12.539-12.538,14.119-12.854s-2.951,15.147-11.59,24.222c0,0,19.853-23.682,28.028-21.693   c3.898,0.948-4.004,15.174-4.847,16.965s-0.211,4.395,2.529,3.883s15.067-10.732,15.067-10.732",
                "duration": 300
            },
            {
                "path": "M138.126,58.333c0,0,6.006-4.425,2.845-6.427s-14.541,0.738-16.648,14.119s18.018,1.896,26.131-6.85   s24.55-28.659,24.55-28.659S147.5,67.831,155.333,72.141s29-23.69,29-23.69s-11.179,21.824-7.667,23.167   c5.734,2.192,22.5-19,24-18.667s-9.167,19.783-5,19.642s29.901-25.123,30.5-26.642c1.07-2.713-5.667-0.937-5.667,4.198   s4.42,25.046-3.227,27.104c-7.571,2.038-9.217-6.639,1.727-9.803c12.097-3.497,17.667-8.597,22.333-13.215s6.167-2.952,2.667,3.048   s-8.099,14.127-6,14.667c3.884,1,20.5-14.93,23.167-17.715c0,0-10.333,5.215-9.833,12.715s8.667,9.166,15-0.167s6-15.5,0-16.5",
                "duration": 500
            },
            {
                "path": "M276,63.007c0,0,12.334-15.39,13.667-14.057s-3.167,17.333-12.167,24c0,0,23.294-22.811,27.13-21.15   c5.666,2.452,1.537,8.983-1.13,13.483s-1.5,7,1.333,6.667s13.833-9.667,13.833-9.667",
                "duration": 300
            },
            {
                "path": "M247.667,37.118c0,0,0.667,2.999-2,5.333",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 396,
            "height": 127
        }
    }
};

var mixAndMixologi = {
    "text-_mixtura_and_mixology": {
        "strokepath": [
            {
                "path": "M19.25,71.716c0,0-3.75,1.25-4,6s2.75,9.5,11.25,0s27.25-37,37.5-39.75c0,0-6,15.5-8.25,21.5s-9,23.969-8,23.734  c1-0.235,18.463-23.13,27.25-31.234c4.23-3.902,5.758-7.677,5.758-7.677S76,59.216,71.25,65.966s-12.5,17.75-7,21.5",
                "duration": 200
            },
            {
                "path": "M79.726,72.965c0,0,11.656-10.492,12.997-10.249c1.341,0.243-9.18,19.533-6.499,19.636  c2.681,0.104,12.481-8.871,12.481-8.871",
                "duration": 200
            },
            {
                "path": "M95.714,46.765c0,0-0.103,4.849-1.753,6.396",
                "duration": 200
            },
            {
                "path": "M120.573,53.16c0,0,4.878-2.342,5.203,0.611c0.184,1.669-2.212,8.734-11.805,18.76  c-9.593,10.026-19.907,17.968-18.257,15.698c1.65-2.269,6.086-8.56,8.149-14.853s2.745-10.913,6.478-10.666  c3.733,0.247,3.073,19.641,8.479,19.641c3.502,0,5.673-2.581,8.871-5.365c3.198-2.783,23.208-23.21,25.684-27.024  c2.476-3.815-20.012,27.438-14.545,33.729c5.467,6.292,29.501-21.043,31.977-23.415s-11.825,22.176-5.842,22.793  c5.983,0.618,19.974-16.501,22.346-18.977s-9.119,18.259-5.261,19.083c3.234,0.691,13.114-7.697,17.653-14.693  c4.54-6.996,5.35-11.196,6.69-9.855s6.911,10.521,11.861,6.396c4.951-4.125-7.533,3.966-10.314,10.314  c-3.171,7.239,0.413,9.181,6.086,7.015c5.674-2.166,12.79-10.521,15.885-12.48c3.094-1.96,10.313-7.634,12.996-7.634  c2.684,0-14.75,4.215-16.504,14.528c-1.754,10.314,8.871,8.989,14.854,0.016c5.984-8.973,9.902-14.131,9.902-14.131  s-8.561,9.8-8.457,15.061c0.103,5.261,2.784,7.53,9.592,2.476c6.809-5.054,7.428-7.005,7.428-7.005",
                "duration": 600
            },
            {
                "path": "M136.284,62.055c0,0,15.453-0.866,21.51-1.854",
                "duration": 200
            },
            {
                "path": "M105.236,147.365c0,0,13.701-10.307,18.31-10.912c4.609-0.606-13.885,3.339-16.006,13.944  c-2.304,11.521,6.668,6.912,9.7,4.365c3.032-2.547,12.854-14.915,14.552-17.825c1.698-2.91-12.247,13.581-8.853,18.916  s10.428-0.484,16.491-7.033c6.063-6.548,13.945-16.611,14.794-13.822s-5.941,15.521-11.398,21.826  c-5.457,6.306,18.609-18.73,23.524-20.251c6.669-2.062,5.456,4.729,2.304,10.672c-3.152,5.941-4.001,9.216-0.97,9.337  c3.031,0.121,12.126-7.247,15.157-10.414c3.031-3.167,11.155-8.382,13.823-8.14c2.668,0.243-9.664,0.701-12.854,13.46  c-3.152,12.611,8.834,4.584,13.097,0c4.849-5.215,12.632-24.758,6.304-35.165c-5.456-8.974-18.915-11.396-29.949,4.729",
                "duration": 300
            },
            {
                "path": "M234.314,146.043c0,0-3.75,1.25-4,6s2.75,9.5,11.25,0s27.25-37,37.5-39.75c0,0-6,15.5-8.25,21.5s-9,23.969-8,23.733  c1-0.234,18.463-23.129,27.25-31.233c4.229-3.902,5.758-7.678,5.758-7.678s-4.758,14.928-9.508,21.678s-12.5,17.75-7,21.5",
                "duration": 200
            },
            {
                "path": "M294.79,147.292c0,0,11.656-10.492,12.998-10.249c1.34,0.243-9.181,19.533-6.5,19.636  c2.682,0.103,12.481-8.871,12.481-8.871",
                "duration": 200
            },
            {
                "path": "M310.778,121.092c0,0-0.104,4.849-1.753,6.396",
                "duration": 200
            },
            {
                "path": "M335.637,127.487c0,0,4.878-2.341,5.203,0.612c0.184,1.669-2.213,8.734-11.805,18.76  c-9.594,10.026-19.908,17.968-18.258,15.698c1.651-2.269,6.086-8.56,8.148-14.853c2.064-6.293,2.746-10.913,6.479-10.666  c3.733,0.247,3.073,19.641,8.479,19.641c3.503,0,5.674-2.581,8.871-5.365c0,0,6.603-6.248,8.459-7.383  c1.855-1.135,8.148-5.363,6.91-5.982c-1.237-0.618-10.314,7.84-10.006,15.008c0.254,5.931,6.036,8.88,15.268-2.835  c8.046-10.212,1.238-15.782-0.413-14.751",
                "duration": 250
            },
            {
                "path": "M371.73,147.55c0,0,18.835-18.521,22.335-23.26c3.5-4.74,7.166-8.743,6.332-8.658c-0.832,0.085-17.132,24.902-18.965,31.426  c-1.833,6.524-1.202,12.993,6.132,8.159c7.333-4.834,13.499-11.333,15.167-12.5c1.666-1.167,6.832-5.668,5.166-5.001  s-12.969,12.983-9.984,18.097c3.805,6.523,13.475-0.258,17.25-8.239c3.707-7.834,2.068-11.787-2.098-11.321",
                "duration": 200
            },
            {
                "path": "M423.315,144.777c0,0,11.803-4.688,14.162-8.688c2.361-4-5.037-1.872-9.662,4.878s-6.961,12.297-4.5,13.75  c3.055,1.805,13.75-6.252,16.625-9.938c2.875-3.686,7.75-9.437,7.875-10.937s-8.625,17.125-15.125,26.625s-19.125,21.625-24,22.125  s-6.375,0-0.875-7.25s19.625-14.625,24.25-16.125s14.127-6.875,15.75-8.125c1.625-1.25,12.625-14.125,12.625-15.75  s-12.875,16.042-6.543,18.042c6.334,2,22.334-13,24.334-17.333s-11.666,17.797-18.666,26.897c-7,9.102-31.168,35.937-49.5,21.77",
                "duration": 250
            }
        ],
        "dimensions": {
            "width": 487,
            "height": 214
        }
    }
};

var beyondMixology = {
    "text-_mixtura_beyond_mixology": {
        "strokepath": [
          {
              "path": "M36.25,69.251c0,0-3.75,1.25-4,6s2.75,9.5,11.25,0s27.25-37,37.5-39.75c0,0-6,15.5-8.25,21.5s-9,23.969-8,23.734   S83.213,57.606,92,49.501c4.23-3.902,5.758-7.677,5.758-7.677S93,56.751,88.25,63.501s-12.5,17.75-7,21.5",
              "duration": 300
          },
          {
              "path": "M96.726,70.5c0,0,11.656-10.492,12.997-10.249s-9.18,19.533-6.499,19.636s12.481-8.871,12.481-8.871",
              "duration": 300
          },
          {
              "path": "M112.714,44.3c0,0-0.103,4.849-1.753,6.396",
              "duration": 300
          },
          {
              "path": "M137.573,50.695c0,0,4.878-2.341,5.203,0.612c0.184,1.669-2.212,8.734-11.805,18.76s-19.908,17.967-18.257,15.698   s6.086-8.56,8.149-14.853s2.745-10.913,6.478-10.666s3.073,19.641,8.479,19.641c3.502,0,5.673-2.581,8.871-5.365   s23.208-23.21,25.684-27.025s-20.012,27.438-14.544,33.73s29.501-21.043,31.977-23.415s-11.825,22.175-5.842,22.793   s19.974-16.501,22.346-18.977s-9.119,18.259-5.261,19.083c3.234,0.691,13.114-7.697,17.653-14.693s5.35-11.197,6.69-9.856   s6.911,10.521,11.862,6.396s-7.534,3.966-10.315,10.314c-3.171,7.239,0.413,9.181,6.086,7.015s12.79-10.521,15.884-12.481   s10.314-7.633,12.997-7.633s-14.75,4.214-16.504,14.528s8.871,8.989,14.854,0.016s9.902-14.131,9.902-14.131   s-8.561,9.799-8.458,15.06s2.785,7.53,9.593,2.476s7.427-7.005,7.427-7.005",
              "duration": 300
          },
          {
              "path": "M153.284,59.59c0,0,15.453-0.866,21.51-1.854",
              "duration": 300
          },
          {
            "path": "M36.85,141.303c0,0,24.692-35.001,23.985-30.291c-0.337,2.243-11.548,20.155-16.825,29.796   c-7.516,13.73-9.74,19.852-9.139,18.546c4.957-10.757,7.859-17.935,18.422-30.044c2.045-2.345,8.225-10.472,13.105-11.745   c5.687-1.483,4.848,4.22,3.709,6.429c-4.991,9.679-13.229,13.477-13.229,13.477c9.884-6.826,22.254,2.597-0.495,18.92   c-4.22,3.028-10.262-0.87-5.44-3.714c4.902-2.891,12.006,0.351,22.633-7.358c0,0,15.338-3.491,15.859-9.847   s-10.213-2.105-13.672,4.325s-3.413,13.157-0.208,14.794c4.24,2.165,8.647,0.833,15.523-5.313s13.648-15.628,12.189-15.731   s-11.329,16.574-7.072,18.327c4.703,1.937,8.639-2.254,17.594-8.95c8.101-6.057,9.377-12.971,6.98-10.393   S103.731,162.894,89,176.067c-11.222,10.035-23.75,15.75-37.5,5.25",
            "duration": 300
          },
          {
              "path": "M123.966,146.1c0,0,10.737-7.847,11.425-9.636s-9.327,6.79-10.186,11.617c-1.239,6.966,4.129,12.609,12.664,3.8   s8.81-18.308,2.616-17.757",
              "duration": 300
          },
          {
              "path": "M149.157,146.237c0,0,13.215-14.042,14.316-14.179s-1.927,9.607-6.057,16.022s-5.644,7.93-4.818,7.654   s16.862-17.521,21.198-19.96c4.926-2.771,7.433-1.239,6.607,2.753s-9.755,15.604-5.146,17.104   c3.798,1.236,13.406-8.708,16.709-11.048s11.7-8.672,14.453-8.672s-11.586,2.322-12.92,14.155s10.016,4.698,15-3.5   c4.343-7.144,9.337-25.316,2.75-34.001c-5.028-6.629-19.211-8.037-27.98,6.362",
              "duration": 300
          },
          {
              "path": "M244.102,143.179c0,0-3.75,1.25-4,6s2.75,9.5,11.25,0s27.25-37,37.5-39.75c0,0-6,15.5-8.25,21.5s-9,23.969-8,23.734   s18.463-23.129,27.25-31.234c4.23-3.902,5.758-7.677,5.758-7.677s-4.758,14.927-9.508,21.677s-12.5,17.75-7,21.5",
              "duration": 300
          },
          {
              "path": "M304.578,144.428c0,0,11.656-10.492,12.996-10.249c1.342,0.243-9.18,19.533-6.498,19.636s12.48-8.871,12.48-8.871",
              "duration": 300
          },
          {
              "path": "M320.566,118.228c0,0-0.104,4.849-1.754,6.396",
              "duration": 300
          },
          {
              "path": "M345.425,124.623c0,0,4.878-2.341,5.203,0.612c0.184,1.669-2.212,8.734-11.805,18.76s-19.907,17.967-18.257,15.698   s6.086-8.56,8.148-14.853s2.744-10.913,6.479-10.666c3.732,0.247,3.072,19.641,8.479,19.641c3.502,0,5.672-2.581,8.87-5.365   c0,0,6.602-6.248,8.458-7.383s8.148-5.363,6.911-5.982s-10.315,7.839-10.007,15.007c0.254,5.931,6.037,8.88,15.268-2.835   c8.045-10.212,1.237-15.782-0.413-14.751",
              "duration": 300
          },
          {
              "path": "M381.518,144.686c0,0,18.834-18.52,22.334-23.26s7.167-8.743,6.334-8.658c-0.834,0.085-17.133,24.902-18.965,31.426   c-1.834,6.523-1.203,12.993,6.131,8.159s13.5-11.333,15.166-12.5c1.668-1.167,6.834-5.668,5.167-5.001s-12.968,12.984-9.985,18.097   c3.805,6.523,13.475-0.258,17.251-8.239c3.706-7.834,2.067-11.788-2.099-11.322",
              "duration": 300
          },
          {
              "path": "M433.102,141.913c0,0,11.803-4.689,14.164-8.689s-5.039-1.872-9.664,4.878s-6.959,12.297-4.5,13.75   c3.055,1.805,13.75-6.252,16.625-9.938s7.75-9.437,7.875-10.937s-8.625,17.125-15.125,26.625s-19.125,21.625-24,22.125   s-6.375,0-0.875-7.25s19.625-14.625,24.25-16.125s14.128-6.875,15.752-8.125c1.623-1.25,12.623-14.125,12.623-15.75   s-12.875,16.042-6.541,18.042c6.333,2,22.333-13,24.333-17.333s-11.667,17.797-18.667,26.898s-31.167,35.936-49.5,21.769",
              "duration": 300
          },
        ],
        "dimensions": {
            "width": 517,
            "height": 250
        }
    }
};

var Tooltip1 = {
    "arrow-tooltip1": {
        "strokepath": [
            {
                "path": "M55.566,3.606c0,0-24.641,1.523-46.151,24.939",
                "duration": 300
            },
            {
                "path": "M16.086,12.753c0,0-6.535,12.254-6.671,15.793c0,0,14.825-5.521,17.018-5.99",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 61,
            "height": 34
        }
    }
};

var Tooltip2 = {
    "arrow-tooltip2": {
        "strokepath": [
            {
                "path": "M55.566,3.606c0,0-24.641,1.523-46.151,24.939",
                "duration": 300
            },
            {
                "path": "M16.086,12.753c0,0-6.535,12.254-6.671,15.793c0,0,14.825-5.521,17.018-5.99",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 61,
            "height": 34
        }
    }
};

var Tooltip3 = {
    "arrow-tooltip3": {
        "strokepath": [
            {
                "path": "M55.356,4.024c0,0-19.754,16.962-50.777,15.079",
                "duration": 300
            },
            {
                "path": "M21.356,11.225c-6.481,3.244-16.777,7.878-16.777,7.878   s5.319,3.375,16.392,6.37",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 61,
            "height": 30
        }
    }
};

var Tooltip4 = {
    "arrow-tooltip4": {
        "strokepath": [
            {
                "path": "M55.356,4.024c0,0-19.754,16.962-50.777,15.079",
                "duration": 300
            },
            {
                "path": "M21.356,11.225c-6.481,3.244-16.777,7.878-16.777,7.878   s5.319,3.375,16.392,6.37",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 61,
            "height": 30
        }
    }
};

var Tooltip5 = {
    "arrow-tooltip5": {
        "strokepath": [
            {
                "path": "M55.566,3.606c0,0-24.641,1.523-46.151,24.939",
                "duration": 300
            },
            {
                "path": "M16.086,12.753c0,0-6.535,12.254-6.671,15.793c0,0,14.825-5.521,17.018-5.99",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 61,
            "height": 34
        }
    }
};

var UnlikeOtherSVG = {
    "unlikeanyotherpath": {
        "strokepath": [
            {
                "path": "M35.709,126.678c-3.244,4.324-15.031,4.811-5.406-21.082c5.369-14.444,14.325-28.381,28.109-36.219    c4.324-2.434,13.785-6.486,17.568-1.893c4.324,4.865,2.434,18.65,0.811,24.055c-5.676,20.002-17.297,40.004-17.297,61.355    c0,2.973-0.271,7.297,3.783,7.297c3.514,0,11.037-6.852,12.929-9.285c6.217-9.459,11.51-17.791,15.802-29.115",
                "duration": 300
            },
            {
                "path": "M101.658,72.35c3.165,11.436-1.893,30.813-5.406,38.922c-3.783,9.459-8.108,18.379-8.379,28.65    c0,2.432-1.081,6.215,2.433,5.945c2.974-0.27,6.757-8.92,8.379-11.352c10.812-17.029,18.109-37.84,23.245-57.031",
                "duration": 300
            },
            {
                "path": "M122.118,76.297c4.055,9.729,4.946,18.217,2.515,28.758c-1.623,8.648-4.325,16.758-7.028,25.137",
                "duration": 300
            },
            {
                "path": "M124.713,106.135c1.622-6.486,9.379-27.838,18.299-28.65c3.279,3.067,0.27,10.813-2.162,16.758    c-4.055,10.002-6.758,19.461-5.406,30.273c1.081,8.648,5.946,18.92,13.244,24.055c11.082,7.838,24.055,2.432,30.542-8.379",
                "duration": 300
            },
            {
                "path": "M140.309,118.299c9.189-5.676,18.109-13.785,26.488-21.082c7.297-6.488,14.596-16.219,18.649-25.408    c2.702-5.945,6.757-16.486,4.054-23.244c-4.865-12.434-17.406,8.396-18.996,12.203c-5.382,12.893-7.762,21.854-9.113,33.746    c-1.081,8.379-4.849,24.271-3.768,32.65c0.271,2.432-0.811,4.324,2.433,4.324c1.892,0,4.054-3.244,5.136-4.596    c3.243-4.324,24.309-34.271,27.282-43.191",
                "duration": 300
            },
            {
                "path": "M192.744,83.16c-3.514,9.191-5.136,18.109-6.217,27.84c-0.541,3.244-4.045,14.59-0.423,10.791    c3.514-3.684,10.118-12.188,12.281-15.43c3.784-6.217,14.63-23.74,14.63-23.74c3.243-2.703,5.135-7.027,7.567-10.813    c2.433-4.055,5.946-7.568,8.379-11.893c1.352-2.432,3.243-7.297,2.703-10c-1.622-7.297-9.19,2.973-10.541,6.758    c-4.595,11.621-5.677,24.865-8.919,37.029c-2.163,8.918-2.163,20.27-5.947,28.379c-1.081-6.758,2.434-19.189,5.136-25.406    c3.784-8.379,12.433-14.596,20.542-18.109c2.973,6.486-6.758,17.299-10.541,21.893c-4.865,5.947-5.73,6.326-3.514,15.137    c2.869,11.406,5.137,15.893,13.523,24.82c10.157,10.813,20.939,18.043,34.88,21.129c67.591,14.963,62.687-20.273,66.47-20.273",
                "duration": 300
            },
            {
                "path": "M227.883,106.676c6.758,0.539,11.893,0.811,18.109-2.434c5.947-2.973,15.137-8.648,17.299-15.406    c2.703-8.107-2.433-14.596-10.812-11.621c-9.19,3.514-15.406,14.055-17.569,22.973c-2.973,9.73-2.162,32.436,13.516,22.705    c12.162-7.568,20-23.516,25.136-36.488c2.433-6.488,3.243-13.785,3.243-20.813",
                "duration": 300
            },
            {
                "path": "M208.423,56.943c-2.433,5.676-6.216,11.082-12.433,12.975",
                "duration": 300
            },
            {
                "path": "M257.345,50.998c1.892,9.189,11.893,12.703,19.46,12.434c20.813-0.813,40.273-11.082,59.193-19.191    c7.567-3.244,18.379-7.564,26.217-8.105c11.352-1.08,20.271-2.977,31.354,1.889c5.135,2.434,10.812,4.865,11.893,10.813    c1.081,5.404-1.352,14.324-7.568,7.838c-0.811-0.541-1.081-1.082-1.622-1.893",
                "duration": 300
            },
            {
                "path": "M321.942,75.053c-8.649-7.297-18.38,1.893-21.622,9.73c-3.244,7.297-4.865,26.488,2.973,32.164    c7.027,5.135,15.136-2.973,18.649-8.648c5.946-9.191,8.108-22.434,8.108-33.246c0,6.758-7.838,40.273-1.081,42.164    c8.649,2.434,17.839-28.379,18.649-34.055",
                "duration": 300
            },
            {
                "path": "M344.376,70.459c8.919,16.217,3.243,35.137-1.622,51.623c0.812-11.893,7.568-27.568,14.326-36.758    c5.405-7.299,12.973-11.352,21.622-13.244c0,7.568-9.189,17.299-11.892,24.596c-3.785,10.271-6.487,26.758-3.514,37.57    c1.351,4.324,5.945,18.039,15.946,22.434c4.214,1.85,9.189,4.594,14.055,4.865",
                "duration": 300
            },
            {
                "path": "M389.783,74.512c4.865,5.137-1.892,16.082-3.243,22.57c-0.812,4.324-6.487,14.459-3.514,18.783    c3.243,4.865,13.244,0.271,16.217-2.162c11.353-8.648,15.947-21.352,21.894-33.785c-7.839,20.002-15.406,39.461-19.731,60.273    c-2.433,10.271-1.621,20.002-1.081,30.271c2.162-15.406,8.108-31.082,12.974-45.678c5.406-16.758,11.623-32.705,18.92-48.65    c7.298-15.678,18.38-27.299,31.354-38.652c12.433-10.27,23.515-13.783,39.191-13.783",
                "duration": 300
            },
            {
                "path": "M406.189,165.328c17.568,0,30.826-3.398,44.057-15.137c12.719-11.283,17.331-25.121,15.406-41.893",
                "duration": 300
            },
            {
                "path": "M504.925,57.754c-5.136-4.324-17.647-8.92-24.056-6.756c-21.622,7.297-30.81,31.619-30.813,40.543    c-0.005,14.82,10.812,22.434,15.677,24.324c4.595,1.352,11.622,1.082,15.947-0.27c20.001-5.676,28.92-29.191,26.487-48.111",
                "duration": 300
            },
            {
                "path": "M562.766,20.996c-25.677,14.865-41.168,50.484-47.029,68.111c-2.677,8.051-16.494,45.019,3.921,51.93",
                "duration": 300
            },
            {
                "path": "M491.951,78.838c-4.595,0.811-8.92-0.813-10.001-5.137c-1.622-7.297,2.703-15.676,10.001-19.461    c8.649-4.594,15.946-5.676,25.406-5.676c11.893,0,23.245-0.539,34.597,2.434c17.839,4.594,36.759,10.541,54.868,3.514    c5.405-2.434,9.189-7.027,4.865-12.434c-4.325-5.406-13.244-5.945-19.461-5.945c-24.325,0.27-36.759,19.189-48.11,37.84    c-10.001,16.217-16.487,37.84-16.218,56.76c1.081-6.217,3.784-11.893,6.217-17.568c2.433-6.217,4.055-12.703,6.757-18.65    c2.703-6.486,8.92-19.73,17.299-20.271c1.352,3.244-0.812,7.027-1.893,10c-2.702,5.947-5.946,11.623-6.486,18.109    c-0.811,6.758-1.622,14.865,0,21.354c2.433,10.541,5.59,16.131,17.839,22.703c11.081,5.945,36.758,3.244,48.921-3.783    c6.217-3.514,18.651-13.785,22.435-20.002c2.974-5.135,5.676-8.107,2.702-12.703",
                "duration": 300
            },
            {
                "path": "M560.604,102.621c11.082,0,23.785-1.621,32.164-9.459c6.757-6.486,15.998-20.436,0.592-18.543    c-18.379,2.162-24.647,24.76-25.458,39.084c-0.271,5.947,0.811,9.73,7.298,11.354c4.595,1.35,9.189-0.271,12.703-3.244    c9.19-7.568,11.893-16.217,18.109-26.219c6.757-10.811,10.541-23.783,15.406-35.676c1.081,7.027-1.081,16.486,4.324,22.434    c3.784,4.053,14.055,6.486,18.109,1.621c-11.623,4.324-22.704,17.838-28.921,28.109c-8.649,13.785-14.055,33.244-1.352,45.949    c8.649,8.648,28.879,7.223,40.002,3.514c9.73-3.246,18.109-8.65,24.056-14.326c8.92-8.65,18.92-22.975,20.271-35.947    c0.271-1.893,0-3.785,0-5.676",
                "duration": 300
            },
            {
                "path": "M676.827,95.863c-1.081,7.299,5.406,8.379,11.082,8.65c17.839,0.811,26.711-9.189,42.657-16.758    c9.46-4.324,21.67-9.461,31.671-12.164c4.324-1.352,14.596-0.27,18.649,2.975c4.865,3.514,3.539,14.338-3.784,11.352",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 804,
            "height": 205
        }
    }
};

var inquerySVG = {
    "txtinquery": {
        "strokepath": [
            {
                "path": "M52.536,26.664c0,0,13.552-8.682,14.611-11.646S56.559,37.887,50.418,44.875s-13.166,12.282-16.43,9.529   s-2.84-11.012,1.818-11.224s11.858,10.376,14.611,10.588s9.953-3.813,15.247-9.741S78.37,29.841,78.793,32.17   s-6.988,18.849-11.858,22.977s23.081-23.824,27.952-21.283s-8.682,18.424-4.023,20.329s16.101-9.329,16.101-9.329   s19.687-9.306,16.934-13.541s-23.751,14.607-16.729,21.812c5.239,5.374,24.352-16.306,24.352-16.306l-23.505,45.527   c0,0,6.818-15.649,44.484-50.983c4.331-4.063-12.085,23.456-5.944,23.032s22.446-21.389,23.293-20.541s-11.224,21.656-6.141,21.945   s24.352-22.368,26.47-22.368s-9.529,20.753-5.929,20.964s16.517-14.188,18.211-17.152s3.176-10.376,5.506-6.988   s6.776,9.952,10.8,6.353s-16.86,11.659-10.931,17.589s21.096-10.178,25.966-20.554s-12.706,14.823-7.624,16.518   s20.54-7.835,24.987-17.152s-13.975,24.564-24.352,34.517s-26.894,26.681-44.469,12.493",
                "duration":100
            },
            {
                "path": "M192.93,17.981c0,0,1.482,4.446-0.847,6.564",
                "duration": 600
            }
        ],
        "dimensions": {
            "width": 293,
            "height": 103
        }
    }
};

var highMarginSVG = {
    "high_profit_margin": {
        "strokepath": [
            {
                "path": "M44.25,56.887c0,0-8.25,1.75-7.5-4.5s6.5-6.5,9.75-2.75s9,11.75,14.25,4.25s4.25-18-3.25-3.75s-14,40.25-19.25,40.25   s-7.75-6.758-2.75-10.879",
                "duration": 300
            },
            {
                "path": "M49.849,68.207c0,0,4.731-5.156,7.151-2.82c2.333,2.251-3.5,8.25,0,10c0,0,7.221,3.977,18.747-15.345   S63.785,72.01,61.166,83.471c-2.968,12.991,5.654,5.61,12.547-0.491s15.593-15.48,15.706-12.655s-10.621,19.447-7.231,20.063   s14.689-10.119,16.158-12.04s9.378-3.729,12.655-9.378S93.487,74.279,94.956,84.9s22.794-11.889,25.294-17.389   S108.625,88.387,106,92.637s-20.5,27.667-28.5,24.334s21.167-23.833,34.333-28s43.167-39.333,44.5-42.5s-25,38.68-26.833,45.34   c0,0,12.166-14.673,18.666-18.173s10.267-5.834,8.217,1.166s-6.55,12.668-3.383,13.834s9.833-0.667,16.167-8.167",
                "duration": 800
            },
            {
                "path": "M91.666,53.804c0,0,0.5,5.166-1.5,7",
                "duration": 300
            },
            {
                "path": "M191.75,81.797c0,0,10.5-14.41,12.25-13.91s2.25,4.5-6.125,16.75s-15.625,31-15.625,36s4.75-28.75,25.75-45.5   s15.61,6.826,7.36,12.326s-12.446,5.406-11.485,2.262c0.957-3.132,13.375-5.588,16.125-4.588",
                "duration": 300
            },
            {
                "path": "M228.125,80.887c0,0,6-5.25,7.625-10s2.875-6.375,4.875-3.625s5.75,8.75,9.25,5.625s-7.604,4.67-10,11   c-3,7.924,3.5,9.25,14,0.625s15.875-13.125,14.875-13.875s-9.739,9.541-10.625,14.375c-1.375,7.5,7.375,9.5,13.25,1.75   s9.25-16.125,3-18",
                "duration": 300
            },
            {
                "path": "M282.875,80.762c0,0,25.25-28.125,28.875-32.125s-14.25,19.625-24.375,38.25s-15.25,28.625-7.5,22.5   s25.625-28.875,23.75-32.25s-6.649-3.331-8.95,0.419S297,89.137,306.25,81.262s14.125-12.5,14.375-10.75s-9.75,18.625-7.75,19.25   s17.5-13.25,24.125-20.25s10.375-11.75,10.375-11.75S336,74.363,334.25,79.688s-4.054,11.561,0.25,12.004   c6.75,0.695,17.375-11.43,17.375-11.43",
                "duration": 800
            },
            {
                "path": "M324.75,53.887c0,0-0.625,5.25-2.375,6.5",
                "duration": 300
            },
            {
                "path": "M 330.375 69.637 L 353.25 67.512",
                "duration": 300
            },
            {
                "path": "M375.099,80.957c0,0,12.366-12.5,13.71-10.753s-7.662,16.802-11.963,20.699s12.902-11.291,15.86-14.113   s12.098-9.813,12.098-4.57s-9.544,17.205-8.334,17.205s24.194-22.108,27.151-19.388s-13.038,20.329-9.543,20.866   s18.415-10.216,21.237-13.173s10.483-7.384,13.172-7.926s-14.516,4.565-15.457,13.975s5.377,7.259,7.931,5.377   s7.393-6.12,8.871-8.504s7.796-10.887,7.796-10.887s-9.679,9.041-9.141,17.777s14.518-3.839,18.012-8.035s6.721-9.304,7.124-11.589   s1.881-2.822,4.301,0s4.705,6.587,7.931,5.242s-1.247-1.006-7.125,6.347c-4.167,5.213-3.763,9.782-0.134,10.589   s13.979-6.721,17.204-9.946s14.382-7.661,14.382-11.021s-17.474,7.526-15.995,15.322c1.607,8.478,13.173,0.135,24.598-15.188   c0,0-10.887,24.061-21.506,34.41s-21.506,15.994-20.431,11.29s14.382-18.213,27.285-23.152s23.657-13.812,26.883-17.44   s8.064-7.527,5.107-1.075s-7.528,17.07-4.974,17.07s18.414-16.667,21.237-19.893s5.646-3.897,3.764,1.613   s-10.888,19.233-10.888,19.233s11.695-14.53,19.625-18.428s12.365-4.974,8.736,2.957s-7.124,13.308-4.032,13.979   s11.829-5.376,14.248-9.543",
                "duration": 800
            },
            {
                "path": "M539.483,53.939c0,0,0.537,5.108-0.941,6.99",
                "duration": 300
            }
        ],
        "dimensions": {
            "width": 610,
            "height": 160
        }
    }
};

var testimonial = {
  "testimonialpath": {
      "strokepath": [
          {
              "path": "M54.722,53.517c0,0-9.412,4.298-14.894,0s-1.98-9.552,8.845-11.939s51.1-6.209,39.638-14.805",
              "duration": 300
          },
          {
              "path": "M63.807,48.9c0,0-0.807-4.616-3.513,0S51.22,67.047,44.852,71.664s-12.576,6.845-13.213,1.592s1.751-11.461,6.368-8.596   s9.233,10.188,13.213,9.869s14.554-8.803,14.554-8.803s12.892-3.928,15.055-8.721c2.942-6.518-7.96-7.468-12.895,3.038   s-2.387,14.009,1.592,14.964s9.422,0.087,31.679-23.083c4.369-4.549,1.431-6.693-0.955-1.592s2.08,15.971,0.647,22.498   s-5.708,8.551-9.562,7.748c-3.991-0.831-3.661-7.642,4.935-10.029s12.57-3.34,17.97-8.34c6.02-5.574,17.848-19.837,17.848-19.837   s-22.713,32.902-13.213,34.437c8.342,1.348,29.77-23.452,30.406-21.383s-10.347,21.333-6.368,20.218s23.401-22.287,25.311-20.218   s-10.984,20.377-10.984,20.377s20.217-20.695,24.833-20.377s3.82,8.12-5.89,20.536c0,0,25.152-25.313,27.381-20.536   s-14.486,21.81-8.596,20.536s28.017-20.536,28.017-20.536s-10.825,5.253-11.302,13.372s7.641,9.71,13.213,2.388   s8.596-17.67,2.388-17.033",
              "duration": 900
          },
          {
              "path": "M236.04,65.615c0,0,13.372-16.556,14.646-14.486s-5.89,19.74-12.895,24.834c0,0,20.106-22.746,27.885-21.197   c5.699,1.135-1.686,9.97-4.176,14.51c-2.125,3.875,0.257,9.059,5.669,5.715s21.881-22.11,23.632-20.2s-10.825,20.059-7.323,20.218   s13.849-10.62,17.67-13.19s13.054-7.027,13.054-7.027s-16.126,5.453-15.919,17.192c0.217,12.293,17.274-6.12,19.262-9.073   c2.302-3.42,5.955-9.384,5.955-9.384s-14.583,22.129-7.865,22.597c9.865,0.688,43.937-42.504,43.937-42.504   s-30.467,41.248-18.089,41.833c9.606,0.454,32.098-28.302,32.098-28.302s-6.845,3.157-6.049,9.856s3.035,21.499-3.662,23.573   c-7.494,2.321-11.001-6.445-0.478-10.029c10.174-3.465,8.279-1.751,15.442-5.094",
              "duration": 700
          },
          {
              "path": "M151.796,39.349c0,0,1.433,3.662-0.796,5.891",
              "duration": 100
          },
          {
              "path": "M292.796,39.349c0,0,1.433,3.662-0.796,5.891",
              "duration": 100
          },
          {
              "path": "M115.563,54.524c0,0,15.551,0.295,21.358-1.969",
              "duration": 100
          }
      ],
      "dimensions": {
          "width": 464,
          "height": 115
      }
  }
};

var ourNaturalProcess = {
    "ourNaturalpro": {
        "strokepath": [
            {
                "path": "M42.497,24.416c0,0-6.714-1.344-9.232,7.218s-2.518,15.611,0,12.254s13.597-23.333,10.239-25.179   s-16.618,6.716-21.821,18.465s-5.751,27.455-0.345,28.374c9.084,1.544,25.318-19.452,26.304-31.722   c0.677-8.433-4.444-9.353-4.444-9.353",
                "duration": 300
            },
            {
                "path": "M46.5,55c0,0,12.75-13.414,13.75-12.957S47.123,63.365,53.306,65c6,1.586,22.124-19.881,23.374-19.881   S68.25,64.063,71.75,64.531s15.38-9.549,18.38-16.049s4.325-10.777,6.075-8.027S101.5,50,106.5,46.75s-6.057,2.865-9.75,9.76   c-4.125,7.701,0,10.086,6,8.038S115,54.75,115,54.75",
                "duration": 300
            },
            {
                "path": "M162.5,29.5c0,0-15.75,34.744-20.75,35.747s-6-3.247-3-7.247",
                "duration": 300
            },
            {
                "path": "M149.781,40.75c0,0-0.309-8.803,3.219-14.25c3.749-5.789,13.386-10.213,14.136-1.713S161.362,69.5,161.362,69.5   s8.638-25,15.888-33.75s10-11.75,15-14.75s15.5-4,10,6.5",
                "duration": 300
            },
            {
                "path": "M178.684,55.272c0,0,18.476-9.607,18.707-11.039s-12.472,1.735-15.243,12.276s4.62,9.849,8.083,7.077   s14.549-18.384,15.011-19.354s-10.854,14.272-8.545,19.585s8.545,0.691,20.785-12.703s18.245-19.399,18.245-19.399   s-19.862,29.331-16.167,33.257s14.319-2.541,20.785-9.7s13.164-14.55,13.164-14.55s-11.547,21.71-7.804,23.791   c4.834,2.688,20.506-13.629,24.201-19.172c0,0-9.93,20.146-6.466,20.004s14.781-9.149,18.707-15.153s3.474-11.547,5.778-10.161   s5.075,8.687,8.54,8.5s4.388-3.651,2.31-2.496s-10.85,11.229-10.85,15.474c0,6.929,5.769,5.543,15.469-2.078   s15.475-14.69,20.555-15.197s-13.164,1.571-15.474,14.966c-2.42,14.033,13.395,0.924,18.014-5.312s7.16-9.84,6.005-9.654   s-12.239,18.2-7.159,19.816s10.393,0.461,44.572-40.647c0,0-20.072,28.426-20.785,36.259c-0.693,7.621,6.005,6.618,17.552-4.388",
                "duration": 300
            },
            {
                "path": "M 218.406 44.233 L 240.346 41.647",
                "duration": 300
            },
            {
                "path": "M404.087,28.021c0,0,7.159-11.414,8.314-9.056s-13.627,26.606-16.859,35.152s-3.232,12.161-3.232,12.161",
                "duration": 300
            },
            {
                "path": "M395.773,35.412c0,0,3.877-11.522,10.623-13.857c7.764-2.688,18.739-0.303,18.046,8.242s-7.938,15.721-12.558,16.875   s-7.395-1.367-5.315-5.063s4.81-3.038,4.81-3.038",
                "duration": 300
            },
            {
                "path": "M417.333,55.667c0,0,4.947-4.759,7.141-8.713s2.86-7.955,5.193-5.621s4.499,7.143,7.666,6.821S441.667,45.667,440,46   s-10.336,10.272-10.954,15.333c-0.713,5.834,5.137,4.833,11.712,0s19.075-15.271,18.742-16.552s-10.342,8.238-11.167,14.052   c-1,7.048,5.668,8,10.668,4s13.832-18,4.832-19.5",
                "duration": 300
            },
            {
                "path": "M486.168,50.667c0,0,5.393-3.533,4.166-5.667c-2.024-3.522-7.927-1.415-12.833,2.834c-5.955,5.157-5.4,14.043-2,15.999   c4.252,2.446,11.708-0.759,19.875-9.759c0,0,14.977-3.595,15.811-7.882s-3.853-6.689-8.186-2.524s-9.334,12.728-8,17.499   c1.429,5.112,7.067,7.063,15.836-0.131C519.903,53.598,534.335,41,533.668,38s-5.333,2.166-4.5,10.333s3.585,21.085-5.834,22.334   c-8.47,1.123-5.666-7.666,1.167-10s11-0.5,21.5-10.667s13.667-12.723,11.667-12.861s-6.167,2.695-5.167,12.528   s2.691,17.307-3.5,19.833c-5.508,2.247-9.5-2.667-4.5-6.167S555.466,58.5,558.233,58s5.768-2.667,5.768-2.667",
                "duration": 200
            }
        ],
        "dimensions": {
            "width": 580,
            "height": 97
        }
    }
};

/*
 Setup and Paint your lazyline!
 */

$(document).ready(function(){
    //$(window).load(function(){
        $('#text-quality-01').lazylinepainter(
        {
            "svgData": qualitySpec,
            "strokeWidth": 3,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#text-quality-01').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#text-great-01').lazylinepainter(
        {
            "svgData": greatTaste,
            "strokeWidth": 3,
            "strokeColor": "#728497",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
                data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#text-great-01').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#text-flexible').lazylinepainter(
        {
            "svgData": flexibleConsistent,
            "strokeWidth": 3,
            "strokeColor": "#728497",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
                data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#text-flexible').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#text-Conclusion-06').lazylinepainter(
        {
            "svgData": Conclusion,
            "strokeWidth": 3,
            "strokeColor": "#d1c3a1",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#text-Conclusion-06').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#text-_mixtura_and_mixology').lazylinepainter(
        {
            "svgData": mixAndMixologi,
            "strokeWidth": 3,
            "strokeColor": "#d1c3a1",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#text-_mixtura_and_mixology').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#text-_mixtura_beyond_mixology').lazylinepainter(
        {
            "svgData": beyondMixology,
            "strokeWidth": 3,
            "strokeColor": "#d1c3a1",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#text-_mixtura_beyond_mixology').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#arrow-tooltip1').lazylinepainter(
        {
            "svgData": Tooltip1,
            "strokeWidth": 2,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#arrow-tooltip1').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#arrow-tooltip2').lazylinepainter(
        {
            "svgData": Tooltip2,
            "strokeWidth": 2,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#arrow-tooltip2').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#arrow-tooltip3').lazylinepainter(
        {
            "svgData": Tooltip3,
            "strokeWidth": 2,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#arrow-tooltip3').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#arrow-tooltip4').lazylinepainter(
        {
            "svgData": Tooltip4,
            "strokeWidth": 2,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#arrow-tooltip4').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#arrow-tooltip5').lazylinepainter(
        {
            "svgData": Tooltip5,
            "strokeWidth": 2,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#arrow-tooltip5').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#unlikeanyotherpath').lazylinepainter(
        {
            "svgData": UnlikeOtherSVG,
            "strokeWidth": 5,
            "strokeColor": "#505251",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#unlikeanyotherpath').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#txtinquery').lazylinepainter(
        {
            "svgData": inquerySVG,
            "strokeWidth": 2,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#txtinquery').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#high_profit_margin').lazylinepainter(
        {
            "svgData": highMarginSVG,
            "strokeWidth": 4,
            "strokeColor": "#798993",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#high_profit_margin').addClass('complete');
            }
        }).lazylinepainter('erase');

        $('#testimonialpath').lazylinepainter(
        {
            "svgData": testimonial,
            "strokeWidth": 4,
            "strokeColor": "#fff",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#testimonialpath').addClass('complete');
            }
        });
        $('#ourNaturalpro').lazylinepainter(
        {
            "svgData": ourNaturalProcess,
            "strokeWidth": 4,
            "strokeColor": "#505251",
            'strokeOpacity': 0,
            'onStrokeStart': function(data) {
              data.el.style.strokeOpacity = 1;
            },
            'onComplete':function(){
              $('#ourNaturalpro').addClass('complete');
            }
        }).lazylinepainter('erase');
    //});
});
